module.exports = __webpack_public_path__ + "img/鼠标穿透演示.592e13c5.gif";